<template>
  <router-view></router-view>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Home.vue